<template>
  <with-error-message :show-error="isItemError"
                      :character-limit="isDisabled ? null : item.lengthLimit"
                      :character-count="action[item.id] ? action[item.id].length : 0"
  >
    <div class="flex justify-between items-baseline">
      <base-label :id="item.id"
                  :label="item.label"
                  :tooltip="item.tooltip"
      />
      <span class="text-xs text-gray-dark">
        {{ tokenCount }} tokens
      </span>
    </div>
    <t-textarea :id="item.id"
                :name="item.id"
                :value="action[item.id]"
                :placeholder="placeholder"
                class="mt-1 border-gray focus:border-focus"
                :variant="isDisabled ? 'textSectionDisabled' : 'textSection'"
                :ref="item.id"
                :maxlength="item.lengthLimit"
                :rows="`${rowCount}`"
                :class="{'border-focus-error': isItemError}"
                :disabled="isDisabled"
    />
  </with-error-message>
</template>

<script>
import WithErrorMessage from '@/components/common/WithErrorMessage.vue'

export default {
  name: 'ChatGPTEditorFormRowFull',

  components: { WithErrorMessage },

  props: {
    item: {
      type: Object,
      required: true
    },
    isItemError: {
      type: Boolean,
      required: true
    },
    rowCount: {
      type: Number,
      default: 10
    },
    tokenCount: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    action: {
      type: Object
    }
  },

  mounted() {
    if (this.$refs.prompt) {
      this.$refs.prompt.focus()
    }
  }
}
</script>
